<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp order-list">
			<hwk-left type="credit"></hwk-left>
			<div class="o-l-r">
				<div class="hwk-credit">
					<div class="i i1">
						<div class="l">
							<p>已使用额度(￥)</p>
							<h4>{{consume_money}}</h4>
						</div>
						<div class="r" @click="payShow=true">去还款</div>
					</div>
					<div class="i i2">
						<p>剩余可用额度(￥)</p>
						<h4>{{userMoney}}</h4>
					</div>
					<div class="i i2">
						<p>总额度(￥)</p>
						<h4>{{userAllMoney}}</h4>
					</div>
				</div>


				<div class="filter" v-if="filterShow">
					<el-form ref="form" :model="form" label-width="80px" label-position="right">
						<table class="table-form">
							<tr>
								<td>
									<el-form-item label="业务类型">
										<!-- 1=授信还款,2=授信使用,3=额度退回 -->
										<el-select v-model="form.service_type" placeholder="全部" style="width: 100%;"
											clearable>
											<el-option label="授信还款" value="1"></el-option>
											<el-option label="授信使用" value="2"></el-option>
											<el-option label="额度退回" value="3"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<!-- 支付方式:1=微信,2=支付宝,3=银联 -->
									<el-form-item label="支付方式">
										<el-select v-model="form.type" placeholder="全部" style="width: 100%;" clearable>
											<el-option label="微信" value="1"></el-option>
											<el-option label="支付宝" value="2"></el-option>
											<el-option label="银联" value="3"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="支付状态">
										<!-- 0=待支付/待审核,2=已通过,3=支付失败/驳货 -->
										<el-select v-model="form.status" placeholder="全部" style="width: 100%;"
											clearable>
											<el-option label="待支付/待审核" value="0"></el-option>
											<el-option label="已支付" value="2"></el-option>
											<el-option label="支付失败" value="3"></el-option>
										</el-select>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<td>
									<el-form-item label="业务单号">
										<el-input v-model="form.order_id_number" placeholder="请输入" clearable></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="下单日期">
										<el-date-picker v-model="form.times" style="width: 100%;" type="daterange"
											clearable range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd"
											value-format="yyyy-MM-dd" end-placeholder="结束日期">
										</el-date-picker>
									</el-form-item>
								</td>
								<td>
									<div class="footer-btn">
										<div class="btn1 pointer" @click="reset">取 消</div>
										<div class="btn2 pointer" @click="submit">保 存</div>
									</div>
								</td>
							</tr>
						</table>
					</el-form>
				</div>
				<div class="search flex">
					<div class="sl">共 <span>{{total}}</span>条记录</div>
					<div class="sr flex">

						<div class="s2 pointer" @click="filterShow=!filterShow">
							<img src="@/assets/filter.png" alt="" /><span>筛选</span>
						</div>
						<div class="s2 pointer" @click="exportOrder"><img src="@/assets/file.png"
								alt="" /><span>导出</span></div>
					</div>
				</div>
				<div class="hwk-shop-list">
					<table classs="table-shop">
						<tr class="top">
							<td class="td1" @click="changeAll">
								<img src="@/assets/f2.png" alt="" v-if="checked" />
								<img src="@/assets/f1.png" alt="" v-else />
							</td>
							<td class="td2">ID</td>
							<td class="td3">业务类型</td>
							<td class="td3">金额</td>
							<td class="td3">支付方式</td>
							<td class="td3">支付凭证</td>
							<td class="td3">支付状态</td>
							<td class="td4">业务单号</td>
							<td class="td5">交易时间</td>
						</tr>
						<tr v-for="(item,index) in list" :key="index">
							<td class="td1" @click="changeChecked(item,index)">

								<img src="@/assets/f2.png" alt="" v-if="item.checked" />
								<img src="@/assets/f1.png" alt="" v-else />
							</td>
							<td>{{index + 1}}</td>
							<td>
								<!-- 服务类型:1=授信还款,2=授信使用,3=额度退回 -->
								<template v-if="item.service_type == 1">授信还款</template>
								<template v-if="item.service_type == 2">授信使用</template>
								<template v-if="item.service_type == 3">额度退回</template>
							</td>
							<td>￥{{item.money}}</td>
							<td>
								<!-- 支付方式:1=微信,2=支付宝,3=银联 -->
								<template v-if="item.type == 0">-</template>
								<template v-if="item.type == 1">微信</template>
								<template v-if="item.type == 2">支付宝</template>
								<template v-if="item.type == 3">银联</template>
							</td>
							<td>
								<div class="payimg" v-if="item.type == 3">
									<!-- <img :src="http + item.extend_yl_images" alt="" /> -->
									<el-image style="width: 30px; height: 30px" :src="http + item.extend_yl_images"
										:preview-src-list="[http + item.extend_yl_images]">
									</el-image>
								</div>

							</td>
							<td>
								<!-- 支付状态:0=待支付/待审核,2=已通过,3=支付失败/驳货 -->
								<div class="pay-state" v-if="item.status == 2">
									<span class="s1">已支付</span>
								</div>
								<div class="pay-state" v-if="item.status == 0">
									<span class="s2">{{item.type == 3?'待审核':'待支付'}}</span>
								</div>
								<div class="pay-state flex" v-if="item.status == 3"
									@click="seeMsg(item.reject_message)">
									<span class="s3">审核驳回</span><img src="@/assets/help.png" alt="" />
								</div>
							</td>
							<td>{{item.order_number||item.order_id_number}}</td>
							<td>
								{{$timeFormat(item.updatetime,'yyyy-mm-dd hh:MM:ss')||$timeFormat(item.createtime,'yyyy-mm-dd hh:MM:ss')}}
							</td>
						</tr>
					</table>
				</div>
				<div class="pagination">
					<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<navigation :usershow='false'></navigation>

		<el-dialog title="还款" :visible.sync="payShow" width="700px" :close-on-click-modal="false"
			:close-on-press-escape="false">

			<div class="dialog-hk flex">
				<div class="l">还款金额</div>
				<div class="r flex">
					<div class="input"><el-input v-model="money" placeholder="请输入支付金额..."></el-input></div>
					<span class="pointer" @click="changeMoney">还全部</span>
				</div>
			</div>
			<div class="paytype flex">
				<div class="l">支付方式</div>
				<div class="r flex">
					<!-- <div class="i flex" @click="changePayType(0)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==0" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay1.jpg" class="img2" />
					</div> -->
					<div class="i flex" @click="changePayType(1)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==1" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay2.jpg" class="img2" />
					</div>
					<div class="i flex" @click="changePayType(2)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==2" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay3.jpg" class="img2" />
					</div>
				</div>
			</div>
			<div class="payma1" v-if="payType==-1">
				<img src="@/assets/nopay.png" />
				<p>选择支付方式</p>
			</div>
			<div class="payma2" v-if="payType==0">
				<!-- <img :src="alpay" v-if="alpay" /> -->
				<iframe :src="alpay" width="210px" height="210px" frameborder="0" v-if="alpay">
				</iframe>
				<p>请使用<span>支付宝</span>扫码 <br>完成支付</p>
			</div>
			<div class="payma2" v-if="payType==1">
				<img :src="wxpay" v-if="wxpay" />
				<p>请使用<span>微信</span>扫码 <br>完成支付</p>
			</div>
			<div class="payma3" v-if="payType==2">
				<!-- <div class="zh flex" v-for="(item,index) in order_bank_card" :key="index">
					<div class="l">账户信息</div>
					<div class="r flex">
						<div class="i">{{item.gs}}</div>
						<div class="i">{{item.yh}}</div>
						<div class="i">{{item.kh}}</div>
					</div>
				</div> -->

				<div class="zh flex" v-for="(item,index) in order_bank_card2" :key="index">
					<div class="l">账户信息</div>
					<div class="r flex">
						{{item}}
					</div>
				</div>
				<div class="pz">
					<div class="t">支付凭证<span>请打款至账户信息，并上传支付凭证</span></div>
					<!-- <div class="upload">
						<img src="@/assets/logo.png" alt="" />
						<p>添加图片</p>
					</div> -->
					<el-upload class="avatar-uploader" :action="action" :headers="headers" :show-file-list="false"
						:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="imageUrl" :src="http + imageUrl" class="avatar">
						<div class="upload" v-else>
							<img src="@/assets/upimg.png" alt="" />
							<p>添加图片</p>
						</div>
					</el-upload>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="payShow = false" size="small">关闭</el-button>
				<el-button type="primary" @click="submitx" size="small">确认支付</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import hwkLeft from './hwk-left.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation,
			hwkLeft
		},
		data() {
			return {
				input: "",
				payType: -1,
				payShow: false,
				filterShow: false,
				leftType: 'orderList',
				form: {
					service_type: "",
					type: "",
					status: "",
					order_id_number: "",
					times: []
				},
				navlist: ['全部订单', '待支付', '待审核', '待发货', '已发货', '已收货', '已完成', '交易关闭'],
				navindex: 0,
				show1: false,
				show2: false,
				list: [],
				pageSize: 10,
				total: 0,
				input3: "",
				checked: false,
				currentPage: 1,
				http: this.$imgUrl,
				userMoney: 0,
				userAllMoney: 0,
				type: "",
				money: "",
				extend_yl_images: '',
				headers: {
					token: localStorage.getItem('token')
				},
				action: this.$upload,
				imageUrl: "",
				alpay: '',
				wxpay: '',
				order_bank_card: [],
				order_bank_card2: [],
				consume_money: 0,
				timer1: null,
				timer2: null,
			};
		},
		created() {
			this.getlist();
			this.getUserInfo();

			this.getPayType()
			this.getHomeData()
		},
		computed: {

		},
		beforeDestroy() {
			this.clear1()
			this.clear2()
		},
		methods: {
			getPayType() {
				this.$http.get('/api/order/pay_type', {

				}).then(res => {


					let obj = res.data.order_bank_card

					let arr = Object.values(obj)
					this.order_bank_card2 = arr
					arr.forEach(item => {
						this.order_bank_card.push({
							gs: item.split(' ')[0],
							yh: item.split(' ')[1],
							kh: item.split(' ')[2],
						})
					})

				});
			},
			changeChecked(item, index) {
				item.checked = !item.checked
				this.checked = this.list.every(item => item.checked)
				this.$forceUpdate()
			},
			changeAll() {
				this.checked = !this.checked
				this.list.forEach(item => item.checked = this.checked)
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = file.response.data.url;
			},
			beforeAvatarUpload(file) {
				const isJPG = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},
			changeMoney() {
				this.money = parseFloat(this.consume_money)
			},
			submitx() {
				if (this.payType == -1) {
					this.$message({
						message: '请选择支付方式',
						type: 'warning'
					});
					return
				}
				if (!this.money) {
					this.$message({
						message: '请输入金额',
						type: 'warning'
					});
					return
				}
				if (parseFloat(this.money) <= 0) {
					this.$message({
						message: '还款金额有误',
						type: 'warning'
					});
					return
				}

				if (parseFloat(this.money) > parseFloat(this.consume_money)) {
					this.$message({
						message: '还款金额不能大于已使用额度',
						type: 'warning'
					});
					return
				}


				if (this.payType < 2) {
					this.payShow = false
				} else {
					if (!this.imageUrl) {
						this.$message({
							message: '请上传支付凭证',
							type: 'warning'
						});
						return
					}
					this.$http.post('/api/user_impower_believe/create_order', {
						type: 3,
						money: parseFloat(this.money),
						extend_yl_images: this.imageUrl,

					}).then(res => {
						console.log(res)
						this.$message({
							type: 'success',
							message: '操作成功!'
						});
						this.payShow = false
						this.getlist();
						this.getUserInfo();
					});
				}



			},
			getUserInfo() {
				this.$http.get('/api/user/index', {
					params: {

					}

				}).then(res => {
					let user = res.data.user
					let nickname = res.data.user.nickname
					localStorage.setItem('nickname', nickname);

					localStorage.setItem('userinfo', JSON.stringify(res.data.user));
					this.$store.dispatch('setUserInfo', res.data.user);
					// this.userMoney = res.data.user.money
					// this.userAllMoney = res.data.user.money
				});
			},

			getHomeData() {

				this.$http.get('/api/home/index', {

				}).then(res => {

					this.userAllMoney = res.data.user_money.all_money
					this.userMoney = res.data.user_money.money
					this.consume_money = res.data.user_money.consume_money

					function formatNumber(num) {
						if (Number.isInteger(num)) {
							return num + ".00";
						} else {
							// 如果不是整数，可以选择保留两位小数或者其他格式
							return num.toFixed(2);
						}
					}
					this.consume_money = formatNumber(this.consume_money)
				});

			},


			seeMsg(data) {
				this.$alert(data, '审核意见', {
					confirmButtonText: '确定',
					callback: action => {

					}
				});
			},
			submit() {
				this.getlist();
			},
			reset() {
				this.form = {
					service_type: "",
					type: "",
					status: "",
					order_id_number: "",
					times: [],

				}
				this.getlist();
			},
			changePayType(i) {
				if (!this.money) {
					this.$message({
						message: '请先输入金额',
						type: 'warning'
					});
					return
				}
				if (parseFloat(this.money) <= 0) {
					this.$message({
						message: '还款金额有误',
						type: 'warning'
					});
					return
				}

				if (parseFloat(this.money) > parseFloat(this.consume_money)) {
					this.$message({
						message: '还款金额不能大于已使用额度',
						type: 'warning'
					});
					return
				}
				this.payType = i
				if (this.payType == 0 || this.payType == 1) {
					this.$http.post('/api/user_impower_believe/create_order', {
						type: this.payType == 0 ? 2 : 1,
						money: parseFloat(this.money),
						extend_yl_images: '',
					}).then(res => {
						console.log(res)
						if (this.payType == 0) {
							this.alpay = res.data.pay_data
							this.clear1()
							this.timer1 = setInterval(() => {
								this.getData(res.data.id)
							}, 3000)
						}
						if (this.payType == 1) {
							this.wxpay = res.data.pay_data
							this.clear2()
							this.timer2 = setInterval(() => {
								this.getData(res.data.id)
							}, 3000)
						}

					});
				} else {
					this.clear1()
					this.clear2()
				}

			},
			clear1() {
				if (this.timer1) {
					clearInterval(this.timer1)
					this.timer1 = null
				}
			},
			clear2() {
				if (this.timer2) {
					clearInterval(this.timer2)
					this.timer2 = null
				}
			},
			getData(id) {
				this.$http.get('/api/user_impower_believe/info', {
					params: {
						id: id
					}
				}).then(res => {
					console.log(res)
					if (res.data.status == 2) {
						this.clear1()
						this.clear2()
						this.payShow = false
						this.getlist()
					}


				}).catch(() => {

				});
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val
				this.getlist();
			},
			changeNav(index) {
				if (this.navindex != index) {
					this.navindex = index
				}
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},
			getlist() {
				let times = ''
				if (this.form.times.length == 2) {
					times = `${this.form.times[0]} 00:00:00,${this.form.times[1]} 23:59:59`
				}
				this.$http.get('/api/user_impower_believe/index', {
					params: {
						page: this.currentPage,
						limit: this.pageSize,
						service_type: this.form.service_type,
						type: this.form.type,
						status: this.form.status,
						order_id_number: this.form.order_id_number,
						times: times,
						export: 0
					}
				}).then(res => {
					console.log(res)
					this.list = res.data.data
					this.list.forEach(item => item.checked = false)
					this.total = res.data.total
				});

			},


			exportOrder() {
				this.$confirm('导出订单信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/user_impower_believe/index', {
						responseType: 'blob',
						params: {
							page: this.currentPage,
							limit: this.pageSize,
							service_type: this.form.service_type,
							type: this.form.type,
							status: this.form.status,
							order_id_number: this.form.order_id_number,
							times: this.form.times.length == 2 ? this.form.times.toString() : '',
							export: 1

						}
					}).then(res => {
						// let url = URL.createObjectURL(res);

						// 创建一个临时的 <a> 元素用于下载
						const url = window.URL.createObjectURL(new Blob([res]));
						const link = document.createElement('a');
						link.href = url;
						const today = new Date();
						const year = today.getFullYear();
						const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始，转换为字符串后补0
						const day = String(today.getDate()).padStart(2, '0');
						const dateStr = `${year}-${month}-${day}`;
						const randomStr = Math.random().toString(36).substring(2, 8);
						let filename = `授信记录导出-${dateStr}-${randomStr}.xlsx`;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						link.remove(); // 下载完成后移除
						window.URL.revokeObjectURL(url); // 释放内存
						console.log(url)
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.dialog-hk {
		.l {
			font-size: 14px;
			color: #000;
			width: 70px;
		}

		.r {
			flex: 1;
			width: 1px;
			height: 40px;
			line-height: 40px;
			position: relative;

			.input {
				width: 100%
			}

			span {
				position: absolute;
				top: 0;
				right: 20px;
				font-size: 14px;
				color: @color2;
			}
		}
	}

	.payma4 {
		.t {
			height: 40px;
			line-height: 40px;

			.l {

				font-weight: 500;
				font-size: 14px;
				color: #000000;
				text-align: left;
			}

			.r {
				margin-left: 10px;
				color: #A9A9A9;
				font-size: 14px;

				span {
					font-size: 22px;
					font-weight: 600;
				}
			}
		}

		.ma {
			margin-top: 40px;

			img {
				width: 104px;
				height: 104px;
			}

			p {
				font-size: 12px;
				color: #FF233F;
				height: 20px;
				line-height: 20px;
				margin-top: 10px;
			}
		}
	}

	.payma4on {


		.t {
			.r {
				color: @color1;


			}
		}

		.ma {

			p {
				color: #3F3F3F;
			}
		}
	}

	.payma3 {
		.upload {
			width: 100px;
			height: 100px;
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid #EBEBEB;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			text-align: center;
			margin-top: 10px;

			img {
				width: 30px;
				height: 30px;
			}

			p {
				line-height: 20px;
				height: 20px;
				font-size: 14px;
				color: #A9A9A9;
				text-align: center;
				margin-top: 10px;
			}
		}

		.zh {
			margin-top: 20px;

			.l {

				font-size: 14px;
				color: #000000;
				text-align: left;
			}

			.r {
				flex: 1;
				width: 1px;
				margin-left: 20px;
				height: 40px;
				line-height: 40px;
				border: 1px solid #EBEBEB;
				position: relative;
				font-size: 14px;
				color: #3F3F3F;
				padding: 0 10px;
				// &::after {
				// 	content: '';
				// 	position: absolute;
				// 	top: 5px;
				// 	bottom: 5px;
				// 	left: 33.33%;
				// 	width: 1px;
				// 	background-color: #EBEBEB;
				// }

				// &::before {
				// 	content: '';
				// 	position: absolute;
				// 	top: 5px;
				// 	bottom: 5px;
				// 	right: 33.33%;
				// 	width: 1px;
				// 	background-color: #EBEBEB;
				// }

				.i {
					font-size: 14px;
					color: #3F3F3F;
					flex: 1;
					align-items: center;
					text-align: center;
				}
			}
		}

		.pz {
			margin-top: 20px;

			.t {
				text-align: left;
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				color: @color1;
				text-align: left;

				span {
					color: @color2;
					margin-left: 10px;
					font-size: 12px;
				}
			}

			.upload {
				img {}

				p {}
			}

		}
	}

	.avatar {
		width: 100px;
		height: 100px;
		display: block;
	}

	.payma2 {
		padding: 60px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;

		img {
			width: 200px;
			height: 200px;
		}

		p {
			margin-top: 20px;
			font-weight: 500;
			font-size: 14px;
			color: #A9A9A9;
			text-align: center;
			line-height: 24px;

			span {
				color: @color2;
				padding: 0 10px;
			}
		}
	}

	.payma1 {
		padding: 60px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;

		img {
			width: 104px;
			height: 104px;
		}

		p {
			margin-top: 20px;
			height: 20px;
			font-weight: 500;
			font-size: 14px;
			color: #A9A9A9;
			text-align: center;
			line-height: 20px;
		}
	}

	.payprice {


		font-size: 14px;
		color: #000000;
		text-align: left;

		span {
			font-weight: bold;
			font-size: 22px;
			color: #FF6A00;
			text-align: left;
			margin-left: 10px;
		}
	}

	.paytype {
		padding: 20px 0;

		.l {


			font-size: 14px;
			color: #000000;
			text-align: left;
		}

		.r {
			flex: 1;
			width: 1px;
			margin-left: 10px;

			.i {
				margin-right: 30px;

				.img1 {
					width: 16px;
					height: 16px;
				}

				.img2 {
					margin-left: 10px;
					width: 100px;
					height: 30px;
				}
			}
		}
	}

	.hwk-shop-list {
		margin-top: 20px;
		width: 100%;

		table {
			width: 100%;
			border-collapse: collapse;
			border-spacing: 0px;

			.top {
				height: 40px;
				background: #F7F9FA;
				border-radius: 6px 6px 6px 6px;

				td {
					font-size: 14px;
					color: @color1;
					font-weight: 500;
				}

				.td1 {
					width: 40px;
					text-align: center;

					img {
						width: 16px;
						height: 16px;
					}
				}

				.td2 {
					width: 80px;
				}

				.td3 {
					width: 100px;
				}

				.td4 {
					width: 120px;
				}

				.td5 {
					width: 150px;
				}

				.td6 {
					width: 150px;
				}
			}

			tr {
				.td1 {

					text-align: center;

					img {
						width: 16px;
						height: 16px;
					}
				}

				td {
					height: 40px;
					line-height: 40px;
					font-size: 15px;
					color: #8C8C8C;
					border-bottom: 1px solid #F5F5F5;
					padding: 0 5px;
					box-sizing: border-box;

					.pay-state {
						span {
							font-size: 15px;
							color: #8C8C8C;
						}

						.s1 {
							color: #8C8C8C;
						}

						.s2 {
							color: @color2;
						}

						.s3 {
							color: #FF2222;
							margin-right: 5px;

						}

						img {
							width: 18px;
							height: 18px;

						}
					}

					.payimg {
						width: 30px;
						height: 30px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.operate {
						align-items: center;

						.i {
							margin-left: 10px;
							cursor: pointer;

							img {
								width: 15px;
								height: 15px;
							}

							span {
								font-size: 14px;
								color: @color2;
								margin-left: 5px;
							}
						}
					}
				}


			}
		}
	}

	.hwk-credit {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.i {

			height: 100px;
			background: #FFFFFF;
			border-radius: 8px 8px 8px 8px;
			border: 1px solid #F4F4F4;
			padding: 20px;
			box-sizing: border-box;

		}

		.i1 {
			width: 470px;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;

			.l {
				flex: 1;
				width: 1px;

				p {
					font-size: 14px;
					color: @color1;
				}

				h4 {
					margin-top: 5px;
					height: 40px;
					line-height: 40px;
					font-family: DIN, DIN;
					font-weight: bold;
					font-size: 32px;
					color: #3C3A5E;
					text-align: left;
				}
			}

			.r {
				cursor: pointer;
				width: 62px;
				height: 26px;
				line-height: 26px;
				text-align: center;
				font-size: 14px;
				color: #fff;
				background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
				border-radius: 30px 30px 30px 30px;
			}
		}

		.i2 {
			width: 260px;

			p {
				font-size: 14px;
				color: #11192D;
			}

			h4 {
				margin-top: 5px;
				height: 40px;
				line-height: 40px;
				font-family: DIN, DIN;
				font-weight: bold;
				font-size: 32px;
				color: #A9A9A9;
				text-align: left;
			}
		}
	}

	.table-form {

		td {
			width: 33.33%;

			.el-form-item {
				margin-bottom: 0 !important;
			}
		}
	}

	.order-list {
		background-color: #fff;
		padding: 20px;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		border-radius: 10px;

		.hwk-order-list {
			margin-top: 20px;
			width: 100%;

			.item {
				margin-bottom: 20px;

				.i-top {
					width: 100%;
					line-height: 40px;
					height: 40px;
					background: #F0F2FA;
					border-radius: 6px;
					align-items: center;
					justify-content: space-between;
					padding: 0 10px;
					box-sizing: border-box;

					.i {
						text-align: left;
						font-size: 14px;
						color: @color1;
					}

					.i1 {
						width: 40px;
						text-align: center;
					}

					.i2 {
						width: 100px;
						text-align: center;
					}

					.i3 {
						flex: 1;
						width: 1px;
						cursor: pointer;

						span {
							color: #3572F5;
							margin-left: 10px;
							font-size: 14px;
						}

						i {
							color: #3572F5;

						}
					}

					.i3 {
						width: 100px;
						color: @color1;
						font-size: 14px;
					}

				}

				.i-middle {
					align-items: flex-start;

					.i1 {

						flex: 1;
						width: 1px;

						.ii {
							padding: 10px 0;
						}

						.iil {
							flex: 1;
							width: 1px;

							img {
								width: 50px;
								height: 50px;
								background: #FFFFFF;
								border-radius: 6px 6px 6px 6px;
								border: 1px solid #D8D8D8;
								overflow: hidden;
							}

							.con {
								flex: 1;
								width: 1px;
								margin-left: 10px;

								.name {

									font-weight: 500;
									font-size: 14px;
									color: @color1;
									line-height: 20px;
									text-align: left;

								}

								.p {
									font-size: 12px;
									color: #50607A;
									line-height: 20px;
									text-align: left;
								}
							}
						}

						.iir {
							width: 100px;

							p {
								font-size: 14px;
								color: @color1;
								text-align: left;
								line-height: 20px;
							}
						}
					}

					.i2 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;
						}
					}

					.i3 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;

							span {
								color: #868E99;
								font-size: 12px;
							}
						}
					}

					.i4 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;
						}
					}

					.i5 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: #868E99;

						p {
							line-height: 30px;
							text-align: left;
							cursor: pointer;

							span {
								color: @color2;
								margin-right: 10px;
							}
						}
					}

				}

				.i-bottom {
					padding-left: 50px;
					position: relative;

					p {
						text-align: left;
						padding: 5px;
						color: #768098;
						font-size: 14px;
						border-radius: 6px;
						background-color: #F5F7FD;
						text-indent: 10px;

						span {
							margin-right: 30px;
						}
					}

					.sh {
						align-items: center;
						justify-content: flex-end;
						position: absolute;
						right: 10px;
						bottom: 5px;

						img {
							width: 15px;
							height: 15px;
							margin-right: 5px;
						}

						span {
							font-size: 12px;
							color: #FF1717;
						}
					}
				}
			}

			.t {
				height: 40px;
				line-height: 40px;
				background: #F7F9FA;
				border-radius: 6px;
				width: 100%;


				.i {
					font-size: 14px;
					color: @color1;

				}

				.i1 {
					width: 40px;
					text-align: center;
				}

				.i2 {
					flex: 1;
					width: 1px;
				}

				.i3 {
					width: 100px;
				}





			}

		}

		.o-l-r {
			flex: 1;
			width: 1px;
			margin-left: 20px;

			.search {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 20px;

				.sl {

					font-size: 14px;
					color: @color1;
					text-align: left;

					span {
						color: @color2;
						padding: 0 5px;
					}
				}

				.sr {
					flex: 1;
					width: 1px;
					display: flex;
					align-items: center;
					justify-content: flex-end;

					.s1 {
						width: 353px;
					}

					.s2 {
						margin-left: 20px;
						width: 100px;
						height: 34px;
						line-height: 34px;
						background: #FFFFFF;
						border-radius: 20px;
						border: 1px solid #D9D9D9;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 16px;
							height: 16px;
							margin-right: 5px;
						}

						span {
							color: #868E99;
							font-size: 14px;
						}
					}
				}
			}

			.filter {
				margin-top: 20px;
				border-bottom: 1px solid #eee;
			}

			.top-nav {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				border-bottom: 1px solid #eee;

				.item {
					height: 40px;
					line-height: 40px;
					font-size: 16px;
					color: @color1;
					flex: 1;
					cursor: pointer;
				}

				.on {
					color: @color2;
					position: relative;

					&::after {
						content: "";
						position: absolute;
						width: 56px;
						height: 3px;
						background: @color2;
						border-radius: 6px 6px 6px 6px;
						bottom: 0;
						left: 50%;
						margin-left: -28px;
					}
				}
			}
		}


	}

	.pagination {
		padding: 20px 0;
	}

	.footer-btn {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-align: center;

		.btn1 {
			width: 100px;
			height: 34px;
			background: #FFFFFF;
			border-radius: 20px 20px 20px 20px;
			border: 1px solid #D9D9D9;
			color: #868E99;
			font-size: 14px;
			line-height: 34px;
		}

		.btn2 {
			width: 100px;
			height: 34px;
			line-height: 34px;
			background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
			border-radius: 30px 30px 30px 30px;
			color: #fff;
			font-size: 14px;
			margin-left: 20px;
		}
	}
</style>